module.exports = __webpack_public_path__ + "static/img/bonus_0.d100c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/bonus_0.png
// module id = hYse
// module chunks = 0